/**
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 */

export const isEmail = (s) => {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s);
};
export const isMobile = (s) => {
    return /^1[0-9]{10}$/.test(s);
};
export const isPhone = (s) => {
    return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s);
};
export const isURL = (s) => {
    return /^http[s]?:\/\/.*/.test(s);
};
export const isIdCard = (s) => {
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(s);
};
export const isString = (o) => {
    return Object.prototype.toString.call(o).slice(8, -1) === 'String';
};
export const isNumber = (o) => {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Number';
};
export const isBoolean = (o) => {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean';
};
export const isFunction = (o) => {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Function';
};
export const isUndefined = (o) => {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Undefined';
};
export const checkPwd = (s) => {
    return /(?!^(\d+|[a-zA-Z]+|[@#$%^&*_!-]+)$)(^[\w@#$%^&*_!-]{8,20}$)/.test(s);
};
export const isMobileDevice = () => {
    return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
};
